// Tanstack Start server fn — reads the Club's stream config. Returns null both
// when unauthenticated and when the Club has never provisioned; the console
// distinguishes those by whether it rendered behind the auth guard.

import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

import type { StreamConfigView } from '../domain/types';

export const getConfigServerFn = createServerFn({ method: 'GET' }).handler(
	async (): Promise<StreamConfigView | null> => {
		const { getServerAuthService } = await import(
			'../../authentication/composition.server'
		);
		const { getServerTenancyService } = await import(
			'../../../_shared/tenancy/composition.server'
		);
		const { getServerStreamConfig } = await import('../composition.server');

		const auth = getServerAuthService();
		const scope = await auth.resolveTenantScope(getRequest());
		if (!scope) return null;

		const tenancy = getServerTenancyService();
		const streamConfig = await getServerStreamConfig();
		return tenancy.withTenant(scope.clubId, () => streamConfig.getConfig());
	},
);
